import { render, staticRenderFns } from "./AccountPlanHeader.vue?vue&type=template&id=b8d888a4&scoped=true"
import script from "./AccountPlanHeader.vue?vue&type=script&lang=js"
export * from "./AccountPlanHeader.vue?vue&type=script&lang=js"
import style0 from "./AccountPlanHeader.vue?vue&type=style&index=0&id=b8d888a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d888a4",
  null
  
)

export default component.exports